import { create } from 'zustand';

const useAuthStore = create((set) => ({
  darkMode: localStorage.getItem("theme") === "dark",
  toggleDarkMode: () => set((state) => {
    const next = !state.darkMode;
    localStorage.setItem("theme", next ? "dark" : "light");
    document.documentElement.setAttribute("data-theme", next ? "dark" : "light");
    return { darkMode: next };
  }),

  user: (() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  })(),
  token: localStorage.getItem('access_token'),
  isAuthenticated: !!localStorage.getItem('access_token'),

  // "Mode cabinet" — un comptable collaborateur ayant accepté un accès
  // (voir accountingAPI.collaborators) bascule sur le dossier d'un client.
  // Persisté pour survivre à un refresh ; lu par l'intercepteur api.js qui
  // ajoute l'en-tête X-Acting-As-Owner sur chaque requête tant que ce mode
  // est actif — voir app.utils.dependencies.get_accounting_scoped_user côté API.
  actingAsOwnerId: localStorage.getItem('acting_as_owner_id') || null,
  actingAsLabel:   localStorage.getItem('acting_as_label') || null,

  setActingAs: (ownerId, label) => {
    localStorage.setItem('acting_as_owner_id', ownerId);
    localStorage.setItem('acting_as_label', label || '');
    set({ actingAsOwnerId: ownerId, actingAsLabel: label || '' });
  },
  clearActingAs: () => {
    localStorage.removeItem('acting_as_owner_id');
    localStorage.removeItem('acting_as_label');
    set({ actingAsOwnerId: null, actingAsLabel: null });
  },

  login: (token, refreshToken, user) => {
    localStorage.setItem('access_token', token);
    localStorage.setItem('refresh_token', refreshToken);
    localStorage.setItem('user', JSON.stringify(user));
    set({ token, user, isAuthenticated: true });
  },

  setUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user));
    set({ user });
  },

  updateAvatar: (avatarUrl) => {
    set((state) => {
      const updated = { ...state.user, avatar_url: avatarUrl };
      localStorage.setItem('user', JSON.stringify(updated));
      return { user: updated };
    });
  },

  logout: async () => {
    // Blacklist the current access token AND refresh token server-side
    // (fire-and-forget) — sans envoyer le refresh_token ici, il restait
    // valable jusqu'à 30j après logout (côté API, voir app/routers/auth.py).
    try {
      const token = localStorage.getItem('access_token');
      const refreshToken = localStorage.getItem('refresh_token');
      const BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
      if (token) {
        fetch(BASE_URL + '/auth/logout', {
          method: 'POST',
          headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh_token: refreshToken || undefined }),
        }).catch(() => {});
      }
    } catch (_) {}
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    localStorage.removeItem('acting_as_owner_id');
    localStorage.removeItem('acting_as_label');
    set({ token: null, user: null, isAuthenticated: false, actingAsOwnerId: null, actingAsLabel: null });
  },
}));

export default useAuthStore;
